import { render } from "./HideCloseButton.vue?vue&type=template&id=ea26f15c"
import script from "./HideCloseButton.vue?vue&type=script&lang=js"
export * from "./HideCloseButton.vue?vue&type=script&lang=js"
script.render = render

export default script